// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const CustomMapContent = styled.div`
  border-top: 1px solid var(--mb-color-border-neutral);
  padding: 0.75rem 1.5rem;
  justify-content: space-between;
  color: var(--mb-color-text-primary);
  font-weight: 700;
  display: flex;
`;
